<template>
  <section class="main-thanks full-page-section" id="thanks">
    <div class="content">
      <h4>
        Thank you for acknowledging independent music by
        <a
          href
          @click.prevent="toggleSigns"
        >signing the petition</a> and supporting
        <a href v-scroll-to="'#trigger-1'">the most important tag</a> for independent content.
        <a href v-scroll-to="'#letter-view'">The open letter</a> has now been sent to Daniel Ek (Spotify), Jeff Bezos (Amazon), Suzan Wojcicki (YouTube) and Tim Cook (Apple).
        <br>
        <br>We’re waiting for their reply!
      </h4>
    </div>
  </section>
</template>

<script>
import data from '@/data/strings.json'
export default {
  name: 'Thanks',
  data () {
    return {
      page: {},
      strings: data.why
    }
  },
  methods: {
    toggleSigns () {
      this.$emit('toggleSigns')
    }
  },
  props: {
    msg: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.content {
  width: 95%;
  max-width: 1200px;
  padding: 30px;
  @media only screen and (max-width: 600px) {
    width: 100%;
  }
  h4 {
    margin-left: auto;
    margin-right: auto;
    font-size: 3rem;
    line-height: 3.5rem;
    @media only screen and (max-width: 1600px) {
      font-size: 2.8rem;
      line-height: 3.3rem;
      max-width: 1100px;
    }
    @media only screen and (max-width: 1400px) {
      font-size: 2.6rem;
      line-height: 3.2rem;
      max-width: 1000px;
    }
    @media only screen and (max-width: 600px) {
      font-size: 1.45em;
      line-height: 1.2em;
    }
    @media only screen and (max-width: 600px) {
      font-size: 1.45em;
      line-height: 1.2em;
    }
    a {
      margin-bottom: -7px;
      line-height: 1.2em;
    }
    @media only screen and (max-width: 333px) {
      font-size: 1.3em;
      line-height: 1.13em;
    }
    a {
      margin-bottom: -7px;
      line-height: 1.13em;
    }
  }
}
.main-thanks {
}
</style>
